"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/05
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEND_INTERNAL_MESSAGE = exports.RECEIVE_INTERNAL_MESSAGE = void 0;
const SEND_INTERNAL_MESSAGE = {
    CAPABILITIES: "capabilities",
    SETUP_COMPLETE: "setup-complete",
    ASK_INITIALISATION: "ask-initialisation",
    FOCUS_EVENT: "focus-event",
    MEMORY_USAGE: "memory-usage",
};
exports.SEND_INTERNAL_MESSAGE = SEND_INTERNAL_MESSAGE;
const RECEIVE_INTERNAL_MESSAGE = {
    VERSIONS: "versions",
    FEATURE_FLAGS: "feature-flags",
};
exports.RECEIVE_INTERNAL_MESSAGE = RECEIVE_INTERNAL_MESSAGE;
//# sourceMappingURL=const.js.map